// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file service/admin/health_check_admin_service.proto (package service, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";

/**
 *
 *
 * @generated from message service.DatabaseStatus
 */
export class DatabaseStatus extends Message<DatabaseStatus> {
  /**
   * @generated from field: bool connected = 1;
   */
  connected = false;

  /**
   * @generated from field: string host = 2;
   */
  host = "";

  /**
   * @generated from field: string port = 3;
   */
  port = "";

  /**
   * @generated from field: string database = 4;
   */
  database = "";

  constructor(data?: PartialMessage<DatabaseStatus>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.DatabaseStatus";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "connected", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "host", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "port", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "database", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DatabaseStatus {
    return new DatabaseStatus().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DatabaseStatus {
    return new DatabaseStatus().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DatabaseStatus {
    return new DatabaseStatus().fromJsonString(jsonString, options);
  }

  static equals(a: DatabaseStatus | PlainMessage<DatabaseStatus> | undefined, b: DatabaseStatus | PlainMessage<DatabaseStatus> | undefined): boolean {
    return proto3.util.equals(DatabaseStatus, a, b);
  }
}

/**
 *
 *
 * @generated from message service.RedisStatus
 */
export class RedisStatus extends Message<RedisStatus> {
  /**
   * @generated from field: bool connected = 1;
   */
  connected = false;

  /**
   * @generated from field: string host = 2;
   */
  host = "";

  /**
   * @generated from field: string port = 3;
   */
  port = "";

  constructor(data?: PartialMessage<RedisStatus>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.RedisStatus";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "connected", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "host", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "port", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RedisStatus {
    return new RedisStatus().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RedisStatus {
    return new RedisStatus().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RedisStatus {
    return new RedisStatus().fromJsonString(jsonString, options);
  }

  static equals(a: RedisStatus | PlainMessage<RedisStatus> | undefined, b: RedisStatus | PlainMessage<RedisStatus> | undefined): boolean {
    return proto3.util.equals(RedisStatus, a, b);
  }
}

/**
 * AdminHealthCheckArgs メッセージ
 *
 * @generated from message service.AdminHealthCheckArgs
 */
export class AdminHealthCheckArgs extends Message<AdminHealthCheckArgs> {
  constructor(data?: PartialMessage<AdminHealthCheckArgs>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.AdminHealthCheckArgs";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AdminHealthCheckArgs {
    return new AdminHealthCheckArgs().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AdminHealthCheckArgs {
    return new AdminHealthCheckArgs().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AdminHealthCheckArgs {
    return new AdminHealthCheckArgs().fromJsonString(jsonString, options);
  }

  static equals(a: AdminHealthCheckArgs | PlainMessage<AdminHealthCheckArgs> | undefined, b: AdminHealthCheckArgs | PlainMessage<AdminHealthCheckArgs> | undefined): boolean {
    return proto3.util.equals(AdminHealthCheckArgs, a, b);
  }
}

/**
 * AdminHealthCheckReply メッセージ
 *
 * @generated from message service.AdminHealthCheckReply
 */
export class AdminHealthCheckReply extends Message<AdminHealthCheckReply> {
  /**
   * @generated from field: string environment = 1;
   */
  environment = "";

  /**
   * @generated from field: string version = 2;
   */
  version = "";

  /**
   * @generated from field: service.DatabaseStatus database = 3;
   */
  database?: DatabaseStatus;

  /**
   * @generated from field: service.RedisStatus redis = 4;
   */
  redis?: RedisStatus;

  /**
   * @generated from field: string build_mode = 5 [json_name = "build_mode"];
   */
  buildMode = "";

  /**
   * @generated from field: int64 timestamp = 6;
   */
  timestamp = protoInt64.zero;

  constructor(data?: PartialMessage<AdminHealthCheckReply>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.AdminHealthCheckReply";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "environment", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "version", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "database", kind: "message", T: DatabaseStatus },
    { no: 4, name: "redis", kind: "message", T: RedisStatus },
    { no: 5, name: "build_mode", jsonName: "build_mode", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "timestamp", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AdminHealthCheckReply {
    return new AdminHealthCheckReply().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AdminHealthCheckReply {
    return new AdminHealthCheckReply().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AdminHealthCheckReply {
    return new AdminHealthCheckReply().fromJsonString(jsonString, options);
  }

  static equals(a: AdminHealthCheckReply | PlainMessage<AdminHealthCheckReply> | undefined, b: AdminHealthCheckReply | PlainMessage<AdminHealthCheckReply> | undefined): boolean {
    return proto3.util.equals(AdminHealthCheckReply, a, b);
  }
}

